import type { Airflow } from '@aviata/platform-types';

import { getTicketPrice } from './ticket';
import { getBaggagePrice } from './baggages';
import { getSeatMapPrice } from './seat-map';
import { getAdditionalProductsPrices } from './additional-products';
import { getRoamingPrice } from './roaming';
import { getMedicalInsurancePrice } from './medical-insurance';

export const getPriceDetails = (
  productsList: Airflow.Order.Entity['products'],
) => {
  const ticketPrice = getTicketPrice(productsList);
  const baggagePrice = getBaggagePrice(productsList);
  const seatMapPrice = getSeatMapPrice(productsList);
  const additionalProducts = getAdditionalProductsPrices(productsList);
  const roamingPrice = getRoamingPrice(productsList);
  const medicalInsurancePrice = getMedicalInsurancePrice(productsList);

  return {
    ticketPrice,
    baggagePrice,
    additionalProducts,
    seatMapPrice,
    roamingPrice,
    medicalInsurancePrice,
  };
};
